import type {
  ApiEnvironment,
  ApiUser,
} from '#/api/userEnvironment/types/ApiUserEnvironment';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { UserDashboardApiApplicantProfile } from '#/modules/userDashboard/api/applicantProfile/types/UserDashboardApiApplicantProfile';
import type { UserDashboardApiEmptyApplicantProfile } from '#/modules/userDashboard/api/applicantProfile/types/UserDashboardApiEmptyApplicantProfile';
import { isNonAdmin } from '#/utils/userEnvironment';

export function hasResumeDb(
  user: ApiUser | null,
  environment: ApiEnvironment | null,
  locale: I18nLocale,
): boolean {
  if (!environment || !user) return false;
  if (locale !== I18nLocale.EN) return false;

  return environment.isUS || Boolean(user.isRecruitable);
}

export function hasWorkHistoryJobs(
  profile:
    | UserDashboardApiApplicantProfile
    | UserDashboardApiEmptyApplicantProfile,
): boolean {
  if (!profile) return false;

  return profile.workHistoryJobs.length > 0;
}

export function promoteResumeDatabase(
  user: ApiUser | null,
  environment: ApiEnvironment,
  locale: I18nLocale,
) {
  if (!hasResumeDb(user, environment, locale)) return false;

  if (user) {
    if (!isNonAdmin(user)) return false;

    if (user.isRecruitable === false) return false;
    if (user.isRecruitable && user.resumeId) return false;
  }

  return true;
}
